export default "__VITE_ASSET__DOti1Wq5__"